import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import {
  getToken,
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    (process.env.NODE_ENV === 'test' ? 'test-api-key' : undefined),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    (process.env.NODE_ENV === 'test' ? 'test-project' : undefined),
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

const initializeAndValidateAppCheck = async () => {
  if (typeof window === 'undefined') return null;
  if (process.env.NODE_ENV === 'test') return null;

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (process.env.NODE_ENV === 'development') {
    const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN?.trim();
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken || true;
  }

  if (process.env.NODE_ENV !== 'development' && !siteKey) {
    throw new Error(
      'REACT_APP_RECAPTCHA_SITE_KEY no está configurada; App Check no puede iniciarse.'
    );
  }

  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey || 'debug-placeholder'),
    isTokenAutoRefreshEnabled: true,
  });

  // No liberar la aplicación hasta comprobar que el proveedor entrega un token.
  await getToken(appCheck, false);
  return appCheck;
};

export const appCheckReady = initializeAndValidateAppCheck();

// Exportar servicios de Firebase
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'southamerica-east1');

// Configurar persistencia explícitamente
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error configurando persistencia:', error);
});

export default app;
